import type { SxProps, Theme } from "@mui/material";

export const slickOverridesSx: SxProps<Theme> = {
  "& .slick-slide": {
    height: "inherit !important",
  },
  "& .slick-slide > div": {
    height: "100% !important",
  },
  "& .slick-slide > div > div": {
    height: "100% !important",
  },
  "& .slick-slide > div > div > div": {
    height: "100% !important",
  },
  "& .slick-slide > div > div > div > div": {
    height: "100% !important",
  },
  "& .slick-track": {
    display: "flex !important",
  },
  "& .slick-dots": {
    background: "transparent !important",
  },
  "& .slick-arrow:before": {
    display: "none !important",
  },
  "& .slick-dots button:before": {
    color: (th) => th.palette.secondary.light,
  },
  "& .slick-dots .slick-active button:before": {
    color: (th) => th.palette.secondary.light,
  },
};
